import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import {getLoginId, getToken} from "@/utils/auth";

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? 'http://192.168.3.213:9160' : process.env.VUE_APP_Export_API,
  timeout: 100000 // request timeout
})
service.interceptors.request.use(
    config => {
      if (store.getters.token) {
        config.headers['accessToken'] = getToken()
        config.headers['loginId'] = getLoginId()
        config.headers['type'] = 'merchant'
        config.headers['Content-Type'] = 'application/json'
      }
      return config
    },
    error => {
      console.log(error) // for debug
      return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
      if (response.status === 200)
        return response.data
    },
    error => {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            if (error.config.url.includes('/401')) {
              Message({
                message: error.response.data ? error.response.data.message : 'error',
                type: 'error',
                duration: 5 * 1000
              })
            } else {
              router.replace({
                path: '/401'
              })
            }
            return Promise.reject(error.response.data)
          case 403:
            if (error.config.url.includes('/login')) {
              Message({
                message: error.response.data ? error.response.data.message : 'error',
                type: 'error',
                duration: 5 * 1000
              })
            } else {
              router.replace({
                path: '/login'
              })
            }
            return Promise.reject(error.response.data)
          default:
            // Message({
            //   message: error.response.data ? error.response.data.message : 'error',
            //   type: 'error',
            //   duration: 5 * 1000
            // })
            if (error.response.data.code === 500000) {
              router.replace({
                path: '/login'
              })
              return false
            }
            return Promise.reject(error.response.data)
        }
      }
      return Promise.reject(error.response.data)
    }
)

export default service
